import React, { useState, useEffect } from "react";
import { useLocation } from 'react-router-dom';
import { Link } from "react-router-dom";
// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "common/components/MD/MDBox";
import MDButton from "common/components/MD/MDButton";
import MDTypography from "common/components/MD/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "layouts/DashboardLayout";
import DashboardNavbar from "layouts/components/Navbars/DashboardNavbar";
import Footer from "layouts/components/Footer";
import HeaderForm from "layouts/components/HeaderForm";

import Alert from '@mui/material/Alert';

import loading_image from 'common/assets/images/icons/loading-green-loading.gif'

import { ColumnFilter } from "common/components/implemented/Tables/DataTable/ColumnFilter";
import base64ToArrayBuffer from "common/script/base64ToArrayBuffer";
import ExpoPartecipazioniService from "services/API/expo_partecipazioni/ExpoPartecipazioniService";
import { useFarFieraUIController } from "common/context/FarFieraContext";
import ExpoServiziTable from "./ExpoServiziTable";



function ExpoServiziList() {

  const [servizi, setServizi] = useState([]);

  const [ffcontroller] = useFarFieraUIController();
  const { manifestazione } = ffcontroller;

  const [loading, setLoading] = useState(true);


  //per passarmi la variabile se ho salvato e far comparire l'alert
  const location = useLocation();
  const { state } = location != null ? location : { state: { submitted: false, salvato: 'NO', indietro: false } }; // Read values passed on state

  useEffect(() => {

    setServizi([]);

    setLoading(true);
    filtra();

  }, [manifestazione]);

  function filtra() {
    console.log("FILTRO CON " + manifestazione);
    ExpoPartecipazioniService.getServiziRx(manifestazione)
      .then(response => {
        console.log(response.data);
        setServizi(response.data);
        setLoading(false);
      })
      .catch(e => {
        console.log(e);
        setLoading(false);
      });

  }

 async function download_pdf(idModulo,nome_file) {

       ExpoPartecipazioniService.download_pdf_modulo(idModulo)
      .then(response => {

        return response.data;
      })
      .then(blob => {

        var arrrayBuffer = base64ToArrayBuffer(blob); //data is the base64 encoded string
        var blobb = new Blob([arrrayBuffer], { type: "application/pdf" });
        var url = URL.createObjectURL(blobb);
        var a = document.createElement('a');
        a.href = url;
        a.target = "_blank";

        a.download =nome_file;
        ;

        document.body.appendChild(a); // append the element to the dom
        a.click();
        a.remove(); // afterwards, remove the element  
      })
      .catch(error => {
        console.error(error);
      });




  }

  const ppAttributes = [];

  if (servizi.length > 0) {
    servizi.forEach(servizio => {
      let action = (
        <MDBox>
          <Link to="/expo_moduli_val" state={{ modo: 'edit', id_soggetto: servizio.idRichiesta, chiamante: 'expo_moduli_list' }}>
            <MDButton variant="outlined" color={"success"} iconOnly={true}>
              <Icon>edit</Icon>
            </MDButton>
          </Link>
        </MDBox>
      );

      let protocollato_string = "NO";
      if (servizio.protocollato != null && servizio.protocollato) {
        protocollato_string = "SI";

      }
     
  let link = "ERRORE";

      if (servizio.nome_file != null) {

        link = (<MDBox>
          <MDTypography
            variant="button"
            fontWeight="regular"
            color="text"
            sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
            onClick={() => download_pdf(servizio.id_modulo,servizio.nome_file)}
          > {servizio.nome_file}
          </MDTypography>

        </MDBox>
        );
      }

          let num_prot= servizio.protocollo_richiesta;
if(servizio.avi){
  num_prot=servizio.protocollo_richiesta+"A";
}

      ppAttributes.push({
        servizio: servizio,
        id_modulo: servizio.id_modulo,
        nome_file: servizio.nome_file,
        protocollato: servizio.protocollato,
        nome_modello: servizio.nome_modello,
        id_richiesta:servizio.id_richiesta,
        protocollo: num_prot,
        protocollato_string:protocollato_string,
        azienda: servizio.rs_espositore,
        action: action,
        tipologia_espositiva_string: servizio.tipologia_concessa,
        mq: servizio.mqa,
        id_spazio:servizio.id_spazio,
        spazio:servizio.spazio,
        numero:servizio.numero,
        postazione:servizio.spazio+"-"+servizio.numero,
        data_rx:servizio.data_rx,
        link:link,
      })
    });
  }



  const ppTableData = {
    rows: ppAttributes,

    columns: [

      { Header: "Prot.", accessor: "protocollo", Filter: ColumnFilter, width: "5%", align: "left", id: "ser_0" },
       { Header: "Azienda", accessor: "azienda", Filter: ColumnFilter, align: "left", width: "28%", id: "ser_2" },
      { Header: "Tipologia Espositiva Assegnata", accessor: "tipologia_espositiva_string", Filter: ColumnFilter, align: "left", with: "15%", id: "ser_3" },
      { Header: "Mq", accessor: "mq", Filter: ColumnFilter, align: "left", width: "5%", id: "ser_4" },
      { Header: "Postazione", accessor: "postazione", Filter: ColumnFilter, align: "left", width: "12%", id: "ser_5" },
      { Header: "Servizio Richiesto", accessor: "nome_modello", Filter: ColumnFilter, align: "left", width: "10%", id: "ser_6" },
      { Header: "File", accessor: "link", Filter: ColumnFilter, align: "left", width: "10%", id: "ser_7" },
      { Header: "Data Rx", accessor: "data_rx", Filter: ColumnFilter, align: "left", width: "10%", id: "ser_8" },
      { Header: "Protocollato", accessor: "protocollato_string", Filter: ColumnFilter, align: "left", width: "5%", id: "ser_9" },
     

    ],



  };

  const mypagination = { color: 'success', variant: "contained" };




  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>

          <Grid item xs={12}>
            <Card>
              <HeaderForm titolo={"Servizi facoltativi richiesti " + manifestazione} add="" modo="vis" />
              <MDBox pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">

                {(state != null && state.submitted && (state.salvato === 'INS' || state.salvato === 'MOD')) &&

                  <Alert severity="success">Dati salvati con successo!</Alert>}

                {(state != null && state.submitted && state.salvato === 'DEL') &&

                  <Alert severity="success">Dati eliminati con successo!</Alert>}
              </MDBox>


              <MDBox pt={3}>
                <ExpoServiziTable
                  table={ppTableData}
                  nome_tabella="servizi_rx"
                  isSorted={true}
                  entriesPerPage={true}
                  showTotalEntries={true}
                  pagination={mypagination}
                  noEndBorder
                  responsive={true}
                  first_load={state == null || !state.indietro}
                  filtro_server={true}
                  canExport={true}
                  canSend={true}
                  enableColumnFilters={true}
                  chiamante='expo_moduli_list'
                  filtra={filtra}
                />
              </MDBox>
              {loading &&
                <MDBox opacity={1} textAlign="center">
                  <img src={loading_image} alt="loading" width={100} />
                </MDBox>
              }

              {(servizi == null || servizi.length === 0) &&
                <MDBox style={{ height: "200px" }} textAlign='center'>
                  <MDTypography
                    variant="button"
                    fontWeight="regular"
                    color="text"
                    sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                  >
                    Non ci sono servizi Facoltativi richiesti per la manifestazione selezionata.
                  </MDTypography></MDBox>
              }
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}



export default ExpoServiziList;
